// @flow

// Effect Managers
import { call, select, take } from 'redux-saga/effects'

// Constants
import { SELECT_SEASON } from 'hfty-seasons'
import { FIELD_URL } from 'fc-model-assets'

// Selectors
import selectedFarmId$ from 'hfty-assets/src/selectors/selectedFarmId'
import assetsOfSelectedSeason from 'hfty-assets/src/selectors/assetsOfSelectedSeason'

// Controller
import { default as assetsCtrl } from 'fc-ctrl-assets'

export default function *watchSeasonSelected (): Generator<*, *, *> {
  while (true) {
    const { payload } = yield take(SELECT_SEASON)
    let assetsOfCurrentSeason
    let farmId

    if (payload) {
      assetsOfCurrentSeason = yield select(assetsOfSelectedSeason(payload))
    }

    if (payload && !assetsOfCurrentSeason.length) {
      farmId = yield select(selectedFarmId$)
    }

    if (payload && !assetsOfCurrentSeason.length && farmId) {
      yield call(assetsCtrl.read, {
        url: FIELD_URL,
        queryParams: {
          rootAsset: farmId,
          season: Number(payload),
          shape: 'true',
        },
      })
    }
  }
}
